import React from 'react';

const CurrencyDollarCircleIcon = ({ fill = "currentColor", width = "24", height = "24" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_545_651)">
        <path d="M5.66659 9.77794C5.66659 10.6371 6.36303 11.3335 7.22214 11.3335H8.66659C9.58706 11.3335 10.3333 10.5873 10.3333 9.66683C10.3333 8.74636 9.58706 8.00016 8.66659 8.00016H7.33325C6.41278 8.00016 5.66659 7.25397 5.66659 6.3335C5.66659 5.41302 6.41278 4.66683 7.33325 4.66683H8.7777C9.63681 4.66683 10.3333 5.36328 10.3333 6.22239M7.99992 3.66683V4.66683M7.99992 11.3335V12.3335M14.6666 8.00016C14.6666 11.6821 11.6818 14.6668 7.99992 14.6668C4.31802 14.6668 1.33325 11.6821 1.33325 8.00016C1.33325 4.31826 4.31802 1.3335 7.99992 1.3335C11.6818 1.3335 14.6666 4.31826 14.6666 8.00016Z" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_545_651">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default CurrencyDollarCircleIcon;